module.exports = __webpack_public_path__ + "media/images/front/icon_post-pc-312fc6f420f2b09cfd12be840774e44a.png";